import Http from '@/network/http'
export default {
    signin: (form) => {
        return Http.post("v1/auth/token", {
            ...form
        })
    },
    autoSignIn: (data) => {
        return Http.post("v1/auth/token/autoSignIn", {
            ...data
        })
    },
    signout: () => {
        return Http.delete("v1/auth/token/destroy")
    },
    sendResetPasswordLink: (username) => {
        return Http.post("v1/auth/forgot-password", {
            username: username
        })
    },
    resetPassword: (data) => {
        return Http.post("v1/auth/reset-password", data)
    },
    signinByContactNumber(contactNumber) {
        return Http.post("v1/auth/token/contact-number/" + contactNumber)
    },
    register:(form) => {
        return Http.post("v1/auth/register", {
            ...form
        })
    },
    getMode:() => {
        return Http.get("v1/auth/getmode")
    },
    registerInstructor: (data) => {
        return Http.post("v1/auth/registerInstructor", {
            ...data
        })
    },
}